"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Profile = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const atoms_1 = require("../../atoms");
const profile_style_1 = __importDefault(require("./profile.style"));
class Profile extends react_1.Component {
    constructor() {
        super(...arguments);
        this.renderAvatar = () => {
            const { classes, readOnly, userDetails: { img }, onAvatarClick } = this.props;
            if (readOnly) {
                return (jsx_runtime_1.jsx("div", Object.assign({ className: classes.imageContainer }, { children: jsx_runtime_1.jsx(atoms_1.ProfileAvatar, { src: img, className: classes.image }, void 0) }), void 0));
            }
            return (jsx_runtime_1.jsx(atoms_1.Button, Object.assign({ className: classes.imageContainer, onClick: onAvatarClick }, { children: jsx_runtime_1.jsx(atoms_1.ProfileAvatar, { src: img, className: classes.image }, void 0) }), void 0));
        };
        this.renderDetails = () => {
            const { classes, readOnly, userDetails, children, onFieldSubmit } = this.props;
            return (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.userDetails }, { children: [jsx_runtime_1.jsx(atoms_1.EditableLabelField, { label: "Name", value: userDetails.name }, void 0),
                    jsx_runtime_1.jsx(atoms_1.EditableLabelField, { label: "Email", value: userDetails.email }, void 0),
                    jsx_runtime_1.jsx(atoms_1.EditableLabelField, { label: "Phone", value: userDetails.phone, editable: !readOnly, onSubmit: onFieldSubmit('phone') }, void 0),
                    jsx_runtime_1.jsx(atoms_1.EditableLabelField, { label: "Signing Public Key", value: userDetails.signingPublicKey, valueClassName: classes.publicKey }, void 0),
                    jsx_runtime_1.jsx(atoms_1.EditableLabelField, { label: "Encryption Public Key", value: userDetails.encryptionPublicKey, valueClassName: classes.publicKey }, void 0), children] }), void 0));
        };
        this.render = () => {
            const { classes } = this.props;
            return (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.container }, { children: [this.renderAvatar(), this.renderDetails()] }), void 0));
        };
    }
}
exports.Profile = Profile;
Profile.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    readOnly: prop_types_1.default.bool.isRequired,
    userDetails: prop_types_1.default.object.isRequired,
    children: prop_types_1.default.node,
    onAvatarClick: prop_types_1.default.func,
    onFieldSubmit: prop_types_1.default.func
};
Profile.defaultProps = {
    children: null,
    onAvatarClick: () => { },
    onFieldSubmit: () => () => { }
};
exports.default = react_jss_1.default(profile_style_1.default)(Profile);
//# sourceMappingURL=index.js.map